// Every cookie and storage item the site can set. Keep this list in step with
// utils/consent.ts whenever a tracker is added or removed.
export const cookieTable = [
  {
    category: 'Strictly necessary',
    provider: 'Medicolegal Psychiatry',
    name: 'mlp_cookie_consent',
    purpose: 'Stores your cookie choices so we do not ask on every page.',
    duration: '12 months (browser local storage)',
  },
  {
    category: 'Analytics',
    provider: 'Google Analytics',
    name: '_ga',
    purpose: 'Distinguishes visitors to measure site traffic.',
    duration: '2 years',
  },
  {
    category: 'Analytics',
    provider: 'Google Analytics',
    name: '_ga_HT5Z5GWWNY',
    purpose: 'Maintains session state for Google Analytics.',
    duration: '2 years',
  },
  {
    category: 'Analytics',
    provider: 'Microsoft Clarity',
    name: '_clck',
    purpose: 'Keeps a consistent anonymous Clarity user ID across visits.',
    duration: '1 year',
  },
  {
    category: 'Analytics',
    provider: 'Microsoft Clarity',
    name: '_clsk',
    purpose: 'Connects multiple page views into a single session recording.',
    duration: '1 day',
  },
  {
    category: 'Analytics',
    provider: 'Microsoft Clarity',
    name: 'CLID, MUID',
    purpose: 'Identifies the browser to Microsoft across Clarity-enabled sites.',
    duration: 'Up to 1 year',
  },
  {
    category: 'Marketing',
    provider: 'LinkedIn',
    name: 'li_sugr, bcookie, lidc, UserMatchHistory, AnalyticsSyncHistory',
    purpose:
      'Measures the results of our LinkedIn advertising and builds audiences of site visitors for future adverts.',
    duration: '1 day to 3 months',
  },
]
